export interface VenueData {
  slug: string;
  name: string;
  fullName: string;
  website: string;
  location: string;
  address: string;
  neighborhood: string;
  description: string;
  capacity: string;
  area: string;
  parking: string;
  eventTypes: string[];
  features: string[];
  whySilentLectureWorks: string[];
  stibAdvantages: string[];
  localKeywords: string[];
  faqs: { question: string; answer: string }[];
  seoTitle: string;
  seoDescription: string;
  heroImageSeq: string;
  heroImageUrl: string;
  testimonial?: {
    name: string;
    company: string;
    text: string;
    rating: number;
  };
  mapEmbedUrl?: string;
}

// ─── Venue 1: Transamerica Expo Center ─────────────────────────────────────

export const TRANSAMERICA_DATA: VenueData = {
  slug: 'palestra-silenciosa-transamerica-expo',
  name: 'Transamerica Expo Center',
  fullName: 'Transamerica Expo Center — São Paulo',
  website: 'transamericaexpo.com.br',
  location: 'São Paulo, SP',
  address: 'Av. Dr. Mário Vilas Boas Rodrigues, 387 — Santo Amaro, São Paulo, SP',
  neighborhood: 'Santo Amaro',
  description:
    'O Transamerica Expo Center é um dos espaços de eventos mais inovadores e versáteis da América Latina. Com infraestrutura de última geração, o venue conta com salas modulares, acústica impecável, parque tecnológico completo e boulevard premium para eventos corporativos, feiras de negócios, congressos, seminários, formaturas e eventos sociais.',
  capacity: 'Halls modulares de diversos tamanhos',
  area: 'Área total extensa com múltiplos halls',
  parking: 'Estacionamento próprio com capacidade ampliada',
  eventTypes: [
    'Eventos corporativos',
    'Feiras de negócios',
    'Congressos e seminários',
    'Formaturas e eventos sociais',
    'Lançamentos de produto',
    'Convenções de vendas',
  ],
  features: [
    'Localização privilegiada próxima ao aeroporto, trem, metrô e ônibus',
    'Infraestrutura de última geração com internet de alta velocidade',
    'Salas modulares com acústica impecável e climatização',
    'Boulevard premium para networking e lounge',
    'Parque tecnológico integrado',
    'Múltiplos halls no mesmo piso para eventos simultâneos',
  ],
  whySilentLectureWorks: [
    'Os halls modulares do Transamerica permitem múltiplas palestras simultâneas em salas adjacentes — a palestra silenciosa elimina interferência sonora entre espaços',
    'Acústica impecável das salas potencializa a qualidade do áudio dos fones sem fio, garantindo experiência imersiva',
    'Infraestrutura tecnológica robusta permite transmissão estável dos sinais RF dos fones em larga escala',
    'Acesso fácil para logística de equipamentos e equipe técnica da STIB (próximo às principais vias de São Paulo)',
    'Espaço amplo permite configuração de múltiplos canais de áudio para diferentes trilhas ou idiomas',
  ],
  stibAdvantages: [
    'Equipe técnica familiarizada com a infraestrutura do Transamerica Expo Center',
    'Fones sem fio RF com alcance de 500m — cobrem todos os halls e áreas externas do complexo',
    'Capacidade para atender eventos de até 5.000 participantes simultâneos',
    'Montagem rápida: em 30 minutos os fones estão configurados e prontos para uso',
    'Suporte técnico presencial durante todo o evento',
    'Logística otimizada para Santo Amaro e região sul de São Paulo',
  ],
  localKeywords: [
    'palestra silenciosa Transamerica Expo',
    'fones sem fio Transamerica Expo Center',
    'eventos corporativos Santo Amaro palestra silenciosa',
    'aluguel fones evento Transamerica',
    'silent conference Transamerica São Paulo',
  ],
  faqs: [
    {
      question: 'A STIB já realizou palestra silenciosa no Transamerica Expo Center?',
      answer:
        'Sim! A STIB é parceira de diversos eventos realizados no Transamerica Expo Center, incluindo convenções corporativas, feiras de negócios e congressos com múltiplas trilhas de áudio simultâneas. Nossa equipe conhece a infraestrutura do local e otimiza a configuração dos fones para cada tipo de hall.',
    },
    {
      question: 'Quantos participantes cabem em uma palestra silenciosa no Transamerica?',
      answer:
        'A STIB tem capacidade para atender até 5.000 participantes simultâneos com fones sem fio. O Transamerica Expo Center possui halls modulares que se adaptam desde eventos íntimos de 50 pessoas até grandes convenções de milhares de participantes.',
    },
    {
      question: 'Os fones sem fio funcionam nos halls abertos do Transamerica?',
      answer:
        'Sim. Nossos fones sem fio RF funcionam perfeitamente tanto em ambientes fechados quanto abertos do Transamerica Expo Center. O alcance de 500 metros garante cobertura completa em todas as áreas do complexo, incluindo boulevard e espaços externos.',
    },
    {
      question: 'Qual o prazo de antecedência para reservar palestra silenciosa no Transamerica?',
      answer:
        'Recomendamos reservar com pelo menos 2 semanas de antecedência para garantir disponibilidade de equipamentos e equipe técnica. Para eventos em alta temporada ou com mais de 1.000 participantes, sugerimos 1 mês de antecedência.',
    },
    {
      question: 'A STIB entrega e retira os equipamentos no Transamerica?',
      answer:
        'Sim, a STIB oferece logística completa: entrega dos equipamentos no dia do evento, montagem técnica, suporte presencial durante toda a programação e retirada após o encerramento. Atendemos Santo Amaro e toda a Grande São Paulo com equipe própria.',
    },
  ],
  seoTitle:
    'Palestra Silenciosa Transamerica Expo Center | Fones Sem Fio para Eventos',
  seoDescription:
    'Palestra silenciosa no Transamerica Expo Center: aluguel de fones sem fio para eventos corporativos, feiras e congressos em Santo Amaro, SP. Tecnologia premium e suporte técnico. Solicite orçamento!',
  heroImageSeq: 'venuetransamericahero',
  heroImageUrl: '/img/stib/local-convencoes-ext.webp',
  mapEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3654.0!2d-46.6769!3d-23.6421!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDM4JzMxLjYiUyA0NsKwNDAnMzYuOSJX!5e0!3m2!1spt-BR!2sbr!4v1',
};

// ─── Venue 2: Expo Center Norte ────────────────────────────────────────────

export const EXPOCENTER_DATA: VenueData = {
  slug: 'palestra-silenciosa-expocenter-norte',
  name: 'Expo Center Norte',
  fullName: 'Expo Center Norte — São Paulo',
  website: 'expocenternorte.com.br',
  location: 'São Paulo, SP',
  address: 'Rua José Bernardo Pinto, 333 — Vila Guilherme, São Paulo, SP',
  neighborhood: 'Vila Guilherme (Zona Norte)',
  description:
    'O Expo Center Norte é o principal centro de exposições e convenções de São Paulo, recebendo mais de 2 milhões de visitantes por ano. Parte do complexo Cidade Center Norte, o venue integra pavilhões de exposição, convention center, sambódromo, shopping, hotel Novotel e Instituto Center Norte. Ideal para feiras, trade shows, congressos e eventos de grande porte.',
  capacity: 'Milhares de visitantes simultâneos',
  area: 'Área de exposição extensa com múltiplos pavilhões',
  parking: 'Vagas amplas no complexo Cidade Center Norte',
  eventTypes: [
    'Feiras e exposições',
    'Trade shows',
    'Congressos e convenções',
    'Eventos corporativos',
    'Eventos de entretenimento',
    'Lançamentos comerciais',
  ],
  features: [
    '2 milhões+ de visitantes por ano',
    'Múltiplos pavilhões de exposição independentes',
    'Convention Center com auditórios modernos',
    'Sambódromo para grandes eventos ao ar livre',
    'Complexo Cidade Center Norte com shopping e hotel',
    'Infraestrutura completa para eventos internacionais',
  ],
  whySilentLectureWorks: [
    'Os múltiplos pavilhões independentes permitem realizar dezenas de palestras simultâneas sem interferência — cada pavilhão se torna uma sala de palestra silenciosa autônoma',
    'A movimentação de milhares de pessoas no Expo Center Norte exige solução de áudio que funcione em meio ao ruído ambiente — os fones sem fio isolam o participante e garantem clareza total',
    'O convention center possui auditórios com infraestrutura perfeita para transmissão RF de múltiplos canais de áudio',
    'A escala do venue demanda fornecedor com capacidade logística robusta — a STIB entrega e opera 5.000+ fones com suporte técnico dedicado',
    'Eventos internacionais frequentes no Expo Center Norte exigem tradução simultânea e múltiplos idiomas — palestra silenciosa elimina a necessidade de cabines tradicionais',
  ],
  stibAdvantages: [
    'Capacidade para atender eventos de grande porte no Expo Center Norte (até 5.000 fones simultâneos)',
    'Fones RF com alcance de 500m cobrem todos os pavilhões e áreas de circulação',
    'Equipe técnica especializada em ambientes de alta densidade de pessoas e equipamentos eletrônicos',
    'Montagem simultânea em múltiplos pavilhões com sincronização perfeita entre canais',
    'Logística otimizada para zona norte de São Paulo',
    'Tecnologia que funciona mesmo com alta concentração de dispositivos WiFi e celulares no venue',
  ],
  localKeywords: [
    'palestra silenciosa Expo Center Norte',
    'fones sem fio Expo Center Norte eventos',
    'silent conference Expo Center Norte SP',
    'eventos Vila Guilherme palestra silenciosa',
    'feira Expo Center Norte fones sem fio',
  ],
  faqs: [
    {
      question: 'A STIB atende eventos de grande porte no Expo Center Norte?',
      answer:
        'Sim, a STIB tem capacidade completa para atender eventos de qualquer porte no Expo Center Norte. Nosso estoque de 5.000+ fones sem fio permite cobrir desde feiras com centenas de visitantes até grandes congressos com milhares de participantes simultâneos em múltiplos pavilhões.',
    },
    {
      question: 'É possível fazer palestra silenciosa em múltiplos pavilhões simultaneamente?',
      answer:
        'Absolutamente. A tecnologia RF da STIB permite operar canais de áudio independentes em cada pavilhão do Expo Center Norte sem interferência entre eles. Já realizamos eventos com até 6 trilhas de áudio simultâneas em pavilhões diferentes.',
    },
    {
      question: 'Os fones funcionam bem no meio de uma feira movimentada?',
      answer:
        'Sim, essa é uma das grandes vantagens da tecnologia RF que a STIB utiliza. Diferente de sistemas Bluetooth ou WiFi que sofrem com interferências, nossos fones operam em frequências de rádio dedicadas, garantindo áudio cristalino mesmo em ambientes com milhares de dispositivos eletrônicos e alta movimentação.',
    },
    {
      question: 'A STIB oferece tradução simultânea para eventos internacionais no Expo Center Norte?',
      answer:
        'Sim. A STIB oferece tradução simultânea sem cabine usando fones sem fio, ideal para eventos internacionais no Expo Center Norte. Os participantes simplesmente selecionam o canal do idioma desejado nos fones, eliminando a necessidade de cabines de tradução tradicionais.',
    },
    {
      question: 'Qual o tempo de instalação dos fones no Expo Center Norte?',
      answer:
        'A instalação leva de 30 a 60 minutos dependendo do número de pavilhões e canais. Para eventos em múltiplos pavilhões, chegamos com antecedência para configurar cada espaço individualmente e realizar testes de alcance e qualidade de áudio.',
    },
  ],
  seoTitle:
    'Palestra Silenciosa Expo Center Norte | Fones Sem Fio para Feiras e Eventos',
  seoDescription:
    'Palestra silenciosa no Expo Center Norte: aluguel de fones sem fio para feiras, congressos e eventos corporativos na Vila Guilherme, SP. Capacidade para milhares de participantes. Orçamento rápido!',
  heroImageSeq: 'venueexpocenterhero',
  heroImageUrl: '/img/stib/setor-feira.webp',
  mapEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3658.0!2d-46.6150!3d-23.5100!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDMwJzM2LjAiUyA0NsKwMzYnNTQuMCJX!5e0!3m2!1spt-BR!2sbr!4v1',
};

// ─── Venue 3: Frei Caneca ──────────────────────────────────────────────────

export const FREICANECA_DATA: VenueData = {
  slug: 'palestra-silenciosa-frei-caneca',
  name: 'Centro de Convenções Frei Caneca',
  fullName: 'Centro de Convenções Frei Caneca — São Paulo',
  website: 'convencoesfreicaneca.com.br',
  location: 'São Paulo, SP',
  address: 'Rua Frei Caneca, 569 — Consolação, São Paulo, SP — CEP 01307-001',
  neighborhood: 'Consolação (Centro expandido)',
  description:
    'O Centro de Convenções Frei Caneca é um dos espaços mais consolidados e bem localizados de São Paulo para eventos corporativos. Com salas modulares acústicas de 50 a 3.800 lugares, 10.500m² de área construída, heliponto no 6º andar e praça de alimentação com 1.400 lugares, o venue é referência em convenções, congressos e seminários no coração da cidade.',
  capacity: 'Até 3.800 lugares sentados',
  area: '10.500m² de área construída',
  parking: '1.350 vagas de estacionamento',
  eventTypes: [
    'Congressos e convenções',
    'Seminários corporativos',
    'Palestras e workshops',
    'Eventos de grande porte',
    'Reuniões executivas',
    'Lançamentos de produto',
  ],
  features: [
    'Salas modulares acústicas de 50 a 3.800 lugares',
    '10.500m² de área construída em múltiplos andares',
    'Heliponto no 6º andar para acesso VIP',
    'Praça de Alimentação com 1.400 lugares em 2 andares',
    '1.350 vagas de estacionamento próprio',
    '53 hotéis e 9.344 unidades hoteleiras na região',
    'Localização central na Consolação, próximo à Avenida Paulista',
  ],
  whySilentLectureWorks: [
    'As salas modulares acústicas do Frei Caneca são perfeitas para palestra silenciosa — a acústica tratada elimina reverberação e potencializa a qualidade do áudio dos fones',
    'A capacidade de 3.800 lugares sentados em um único hall é ideal para grandes convenções com palestra silenciosa em escala',
    'O heliponto permite logística ágil para entrega de equipamentos e deslocamento da equipe técnica',
    'A localização central na Consolação facilita o acesso de participantes e a logística da STIB proveniente de toda a Grande São Paulo',
    'A estrutura vertical em múltiplos andares permite eventos simultâneos com palestras silenciosas independentes em cada sala',
  ],
  stibAdvantages: [
    'Especialistas em configurar palestra silenciosa em salas modulares acústicas como as do Frei Caneca',
    'Fones sem fio RF com alcance de 500m cobrem todos os andares e salas do complexo',
    'Equipe técnica que conhece a logística de acesso e montagem no Frei Caneca',
    'Capacidade para atender o hall principal completo (3.800 participantes) com fones de qualidade',
    'Suporte técnico presencial em todos os andares durante o evento',
    'Montagem rápida que respeita os horários de programação do venue',
  ],
  localKeywords: [
    'palestra silenciosa Frei Caneca',
    'fones sem fio Frei Caneca eventos',
    'silent conference Frei Caneca SP',
    'eventos Consolação palestra silenciosa',
    'convenção Frei Caneca fones sem fio',
  ],
  faqs: [
    {
      question: 'A STIB já realizou palestra silenciosa no Centro de Convenções Frei Caneca?',
      answer:
        'Sim, a STIB é fornecedora frequente de palestra silenciosa no Frei Caneca. Nossa equipe conhece a logística do prédio, os acessos de serviço, a distribuição elétrica dos halls e a configuração acústica de cada sala, o que garante montagem rápida e operação impecável.',
    },
    {
      question: 'É possível usar palestra silenciosa no hall principal com 3.800 pessoas?',
      answer:
        'Sim! A STIB tem capacidade para atender todo o hall principal do Frei Caneca com 3.800 fones sem fio simultâneos. Nossa tecnologia RF de múltiplos canais permite dividir o público em até 10 trilhas de áudio diferentes dentro do mesmo espaço.',
    },
    {
      question: 'Os fones funcionam nos diferentes andares do Frei Caneca?',
      answer:
        'Sim. A tecnologia RF dos nossos fones tem alcance de 500 metros em linha reta e penetra paredes e pisos com excelente qualidade. Isso garante cobertura completa em todos os andares do Frei Caneca, permitindo eventos simultâneos em salas diferentes.',
    },
    {
      question: 'A STIB faz entrega no estacionamento do Frei Caneca?',
      answer:
        'Sim, a STIB utiliza o acesso de serviço e o estacionamento do Frei Caneca para logística de equipamentos. Nossa equipe coordena previamente com a administração do venue para garantir acesso ágil no dia do evento.',
    },
    {
      question: 'Qual a vantagem de usar palestra silenciosa em vez de som tradicional no Frei Caneca?',
      answer:
        'No Frei Caneca, onde múltiplos eventos podem acontecer simultaneamente em salas adjacentes, a palestra silenciosa elimina interferência sonora entre espaços. Além disso, para convenções com múltiplos idiomas, os fones permitem tradução simultânea sem necessidade de cabines, otimizando o uso do espaço e reduzindo custos.',
    },
  ],
  seoTitle:
    'Palestra Silenciosa Frei Caneca | Fones Sem Fio para Convenções e Eventos',
  seoDescription:
    'Palestra silenciosa no Centro de Convenções Frei Caneca: aluguel de fones sem fio para congressos, convenções e eventos corporativos na Consolação, SP. Capacidade para 3.800 pessoas. Orçamento!',
  heroImageSeq: 'venuefreicanecahero',
  heroImageUrl: '/img/stib/setor-arquitetura.webp',
  mapEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.0!2d-46.6540!3d-23.5530!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDMzJzEwLjgiUyA0NsKwMzknMTQuNCJX!5e0!3m2!1spt-BR!2sbr!4v1',
};

// ─── Venue 4: Distrito Anhembi ───────────────────────────────────────────

export const ANHEMBI_DATA: VenueData = {
  slug: 'palestra-silenciosa-distrito-anhembi',
  name: 'Distrito Anhembi',
  fullName: 'Distrito Anhembi — São Paulo',
  website: 'distritoanhembi.com.br',
  location: 'São Paulo, SP',
  address: 'Av. Olavo Fontoura, 1.209 — Santana, São Paulo, SP',
  neighborhood: 'Santana (Zona Norte)',
  description:
    'O Distrito Anhembi é o maior complexo de eventos de São Paulo e um dos mais importantes da América Latina. Reúne o Anhembi Convention Center, pavilhões de exposição, o Sambódromo, arenas para shows e o hotel Holiday Inn. Ideal para trade shows, congressos massivos, eventos corporativos e entretenimento em grande escala.',
  capacity: 'Dezenas de milhares de pessoas',
  area: 'Área extensa com múltiplos pavilhões e arenas',
  parking: 'Estacionamento amplo no complexo',
  eventTypes: [
    'Trade shows e exposições',
    'Congressos e convenções',
    'Eventos corporativos',
    'Shows e entretenimento',
    'Eventos esportivos',
    'Feiras comerciais',
  ],
  features: [
    'Anhembi Convention Center com auditórios e salas flexíveis',
    'Pavilhões de exposição de grande porte',
    'Sambódromo para eventos ao ar livre e desfiles',
    'Hotel Holiday Inn Anhembi integrado',
    'Infraestrutura para eventos de proporção internacional',
    'Múltiplos espaços para eventos simultâneos',
  ],
  whySilentLectureWorks: [
    'A escala massiva do Distrito Anhembi exige tecnologia de áudio que funcione independente do ruído ambiente — os fones sem fio isolam completamente o participante',
    'Múltiplos pavilhões e arenas permitem dezenas de atividades simultâneas — palestra silenciosa torna cada espaço autossuficiente acusticamente',
    'Eventos no Sambódromo ao ar livre exigem áudio sem fio com alcance extenso — nossos fones RF cobrem 500m mesmo em áreas abertas',
    'A presença de milhares de dispositivos celulares e WiFi no Anhembi exige tecnologia RF (não WiFi/Bluetooth) para evitar interferências — a STIB utiliza exatamente essa tecnologia',
    'Para eventos corporativos dentro de trade shows, a palestra silenciosa permite que participantes assistam palestras dentro de estandes sem isolamento acústico',
  ],
  stibAdvantages: [
    'Capacidade massiva: até 5.000 fones simultâneos para eventos de grande porte no Anhembi',
    'Tecnologia RF imune às interferências de WiFi e celulares em ambientes densamente conectados',
    'Alcance de 500m ideal para os grandes pavilhões e áreas externas do Distrito Anhembi',
    'Equipe técnica especializada em ambientes de grande escala com alta densidade de público',
    'Montagem simultânea em múltiplos espaços do complexo',
    'Logística otimizada para a zona norte de São Paulo',
  ],
  localKeywords: [
    'palestra silenciosa Distrito Anhembi',
    'fones sem fio Anhembi eventos',
    'silent conference Anhembi SP',
    'eventos Santana palestra silenciosa',
    'trade show Anhembi fones sem fio',
  ],
  faqs: [
    {
      question: 'A STIB atende eventos de grande porte no Distrito Anhembi?',
      answer:
        'Sim, o Distrito Anhembi é um dos locais onde a STIB mais opera devido à escala dos eventos. Temos capacidade para atender desde eventos corporativos no Convention Center até grandes feiras nos pavilhões com milhares de participantes simultâneos.',
    },
    {
      question: 'É possível usar palestra silenciosa no Sambódromo do Anhembi?',
      answer:
        'Sim! Nossos fones RF funcionam perfeitamente em ambientes abertos como o Sambódromo do Anhembi. O alcance de 500 metros cobre toda a extensão do espaço, permitindo que participantes circulem livremente enquanto ouvem a palestra com qualidade perfeita.',
    },
    {
      question: 'A tecnologia dos fones da STIB funciona com tanta interferência de WiFi no Anhembi?',
      answer:
        'Exatamente por isso utilizamos tecnologia RF (rádio frequência) em vez de WiFi ou Bluetooth. Em eventos no Anhembi com milhares de pessoas usando celulares simultaneamente, sistemas baseados em WiFi sofriam interferências. Nossa tecnologia RF opera em frequências dedicadas, garantindo áudio cristalino independente da rede do local.',
    },
    {
      question: 'A STIB pode montar palestra silenciosa em múltiplos pavilhões do Anhembi ao mesmo tempo?',
      answer:
        'Sim. A STIB tem equipe e equipamentos suficientes para operar palestra silenciosa em múltiplos pavilhões do Distrito Anhembi simultaneamente. Cada pavilhão recebe sua própria configuração de canais, com suporte técnico dedicado em cada espaço.',
    },
    {
      question: 'Qual o prazo para solicitar orçamento para evento no Anhembi?',
      answer:
        'Recomendamos solicitar orçamento com pelo menos 3 semanas de antecedência para eventos no Distrito Anhembi, especialmente se envolver múltiplos espaços ou grande número de participantes. Isso garante disponibilidade de equipamentos e equipe técnica suficiente.',
    },
  ],
  seoTitle:
    'Palestra Silenciosa Distrito Anhembi | Fones Sem Fio para Grandes Eventos',
  seoDescription:
    'Palestra silenciosa no Distrito Anhembi: aluguel de fones sem fio para trade shows, congressos e eventos corporativos na zona norte de SP. Tecnologia RF para ambientes massivos. Orçamento!',
  heroImageSeq: 'venueanhembihero',
  heroImageUrl: '/img/stib/local-pavilhao-feira.webp',
  mapEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3658.0!2d-46.6410!3d-23.5160!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDMwJzU3LjYiUyA0NsKwMzgnMjcuNiJX!5e0!3m2!1spt-BR!2sbr!4v1',
};

// ─── Venue 5: WTC Events Center ───────────────────────────────────────────

export const WTC_DATA: VenueData = {
  slug: 'palestra-silenciosa-wtc-events-center',
  name: 'WTC Events Center',
  fullName: 'WTC Events Center — São Paulo',
  website: 'wtceventscenter.com.br',
  location: 'São Paulo, SP',
  address: 'Av. das Nações Unidas, 12551 — Cidade Monções, São Paulo, SP — CEP 04795-100',
  neighborhood: 'Brooklin (Cidade Monções)',
  description:
    'O WTC Events Center é um dos centros de convenções mais prestigiados de São Paulo, localizado no complexo World Trade Center. Integrado ao Sheraton São Paulo WTC Hotel e ao Shopping D&D, o venue oferece infraestrutura de ponta com Golden Hall de 3.000m², pé-direito de 16m, teatro com mais de 500 lugares, 4 salas modulares e mais de 60 salas de reunião. Referência em grandes congressos, conferências, eventos corporativos e lançamentos de produto na região da Berrini.',
  capacity: 'Até 2.000 pessoas no Golden Hall',
  area: 'Golden Hall com 3.000m², 4 salas modulares (920m² no total)',
  parking: 'Estacionamento no complexo WTC com acesso pela Marginal Pinheiros',
  eventTypes: [
    'Congressos e conferências',
    'Eventos corporativos',
    'Lançamentos de produto',
    'Treinamentos e workshops',
    'Jantares e eventos sociais',
    'Reuniões executivas',
  ],
  features: [
    'Golden Hall com 3.000m² e pé-direito de 16m',
    'Teatro com mais de 500 lugares e estrutura técnica completa',
    '4 salas modulares totalizando 920m²',
    'Mais de 60 salas de reunião (somando hotel + centro de eventos)',
    'Integrado ao Sheraton WTC Hotel e Shopping D&D',
    'Próximo à estação de trem Berrini e Marginal Pinheiros',
    'Acessibilidade completa com entrada, estacionamento e banheiros adaptados',
  ],
  whySilentLectureWorks: [
    'O Golden Hall com 3.000m² e pé-direito de 16m é perfeito para palestras de grande porte — os fones sem fio eliminam a necessidade de sonorização complexa em ambientes amplos',
    'As 4 salas modulares permitem múltiplas palestras simultâneas sem interferência sonora entre espaços — cada sala se torna uma palestra silenciosa independente',
    'A proximidade com o Sheraton Hotel permite que participantes transitem entre hospedagem e evento sem perder o áudio — os fones RF funcionam em todo o complexo',
    'O WTC recebe eventos internacionais frequentes — a palestra silenciosa com tradução simultânea via fones elimina cabines de tradução tradicionais',
    'As mais de 60 salas de reunião permitem sessões paralelas com canais de áudio independentes — tecnologia RF da STIB suporta essa escala',
  ],
  stibAdvantages: [
    'Equipe técnica que conhece a infraestrutura do WTC Events Center e do Sheraton',
    'Fones sem fio RF com alcance de 500m cobrem todo o complexo (Golden Hall + salas modulares + hotel)',
    'Capacidade para atender até 5.000 participantes — mais que suficiente para o Golden Hall lotado',
    'Tradução simultânea sem cabine: participantes selecionam o idioma direto no fone',
    'Montagem coordenada com a equipe do WTC para respeitar a programação do venue',
    'Logística facilitada pelo acesso à Marginal Pinheiros e proximidade com a Berrini',
  ],
  localKeywords: [
    'palestra silenciosa WTC São Paulo',
    'fones sem fio WTC Events Center',
    'silent conference WTC Berrini',
    'eventos corporativos Brooklin palestra silenciosa',
    'congresso WTC fones sem fio',
  ],
  faqs: [
    {
      question: 'A STIB já realizou eventos no WTC Events Center?',
      answer:
        'Sim, o WTC Events Center é um dos venues onde a STIB atua com frequência, especialmente para congressos e conferências corporativas de grande porte. Nossa equipe conhece a logística de acesso, a distribuição elétrica do Golden Hall e a configuração acústica das salas modulares.',
    },
    {
      question: 'É possível fazer palestra silenciosa no Golden Hall com 2.000 pessoas?',
      answer:
        'Sim! A STIB tem capacidade para atender o Golden Hall do WTC com 2.000 fones simultâneos. O pé-direito de 16m e a acústica do espaço são ideais para transmissão RF sem interferência. Podemos dividir o público em até 10 canais de áudio diferentes.',
    },
    {
      question: 'A STIB consegue atender eventos simultâneos nas 4 salas modulares do WTC?',
      answer:
        'Sim. Nossa tecnologia RF permite operar canais de áudio independentes em cada sala modular sem interferência entre elas. Já realizamos eventos com até 6 trilhas simultâneas no complexo WTC, incluindo salas do hotel Sheraton.',
    },
    {
      question: 'Os fones funcionam no teatro do WTC (500 lugares)?',
      answer:
        'Perfeitamente. O teatro do WTC tem acústica excelente e estrutura técnica profissional. Os fones sem fio da STIB complementam o sistema de som do teatro para tradução simultânea, audiodescrição ou reforço de áudio para participantes com dificuldade auditiva.',
    },
    {
      question: 'A STIB oferece desconto para eventos no WTC que também usam o Sheraton?',
      answer:
        'Sim, oferecemos condições especiais para eventos que combinam o WTC Events Center com hospedagem no Sheraton. A logística integrada reduz custos operacionais, e essa economia é repassada no orçamento. Consulte nossa equipe para pacotes personalizados.',
    },
  ],
  seoTitle:
    'Palestra Silenciosa WTC Events Center | Fones Sem Fio para Congressos e Eventos',
  seoDescription:
    'Palestra silenciosa no WTC Events Center: aluguel de fones sem fio para congressos, conferências e eventos corporativos no Brooklin, SP. Golden Hall, teatro e salas modulares. Orçamento!',
  heroImageSeq: 'venuewtchero',
  heroImageUrl: '/img/stib/local-hotel-salao.webp',
  mapEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3656.0!2d-46.6960!3d-23.6080!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDM2JzI4LjgiUyA0NsKwNDEnNDUuNiJX!5e0!3m2!1spt-BR!2sbr!4v1',
};

// ─── Venue 6: Villa Bisutti ───────────────────────────────────────────────

export const VILLABISUTTI_DATA: VenueData = {
  slug: 'palestra-silenciosa-villa-bisutti',
  name: 'Villa Bisutti',
  fullName: 'Villa Bisutti — São Paulo',
  website: 'bisutti.com.br',
  location: 'São Paulo, SP',
  address: 'Rua Casa do Ator, 642 — Vila Olímpia, São Paulo, SP',
  neighborhood: 'Vila Olímpia (Zona Sul)',
  description:
    'O Grupo Villa Bisutti é referência em espaços para eventos de alto padrão em São Paulo, com unidades icônicas como a Casa do Ator, Gomes de Carvalho e Tenerife. Reconhecido por ambientes sofisticados — lustres de Murano, projeção mapeada, lounges externos e paisagismo exclusivo — o Villa Bisutti é palco de casamentos luxuosos, eventos corporativos de prestígio, formaturas e lançamentos de marca na região mais nobre da Vila Olímpia.',
  capacity: 'Até 500 pessoas (unidade Gomes de Carvalho)',
  area: 'Múltiplas unidades com até 1.000m² (unidade Tenerife)',
  parking: 'Estacionamento com serviço de Valet em todas as unidades',
  eventTypes: [
    'Eventos corporativos de alto padrão',
    'Lançamentos de produto e marca',
    'Convenções e treinamentos VIP',
    'Jantares e coquetéis exclusivos',
    'Formaturas premium',
    'Casamentos e eventos sociais',
  ],
  features: [
    'Ambientes sofisticados com lustres de Murano e projeção mapeada',
    'Múltiplas unidades na Vila Olímpia (Casa do Ator, Gomes de Carvalho, Tenerife)',
    'Unidade Tenerife: 1.000m² com pé-direito de 7,5m e palco suspenso',
    'Sistema de projeção multi-telas integrado',
    'Lounge externo com paisagismo exclusivo',
    'Serviço de Valet e acessibilidade completa',
    'Equipe de catering própria com cardápio premium',
  ],
  whySilentLectureWorks: [
    'O Villa Bisutti é conhecido por ambientes requintados onde a estética é tão importante quanto a funcionalidade — os fones sem fio eliminam caixas de som e cabos visíveis, preservando a beleza do espaço',
    'As unidades com múltiplos ambientes (salão principal, mezanino, lounge externo) permitem programação simultânea com canais de áudio independentes em cada área',
    'O pé-direito de 7,5m da unidade Tenerife é perfeito para palestras com projeção em tela grande — o áudio via fones mantém todos os participantes imersos mesmo nas últimas fileiras',
    'Eventos corporativos de alto padrão exigem experiência impecável — os fones sem fio garantem que cada palavra do palestrante seja ouvida com clareza cristalina',
    'O lounge externo com paisagismo permite coffee breaks e networking sem perder a transmissão — os fones RF funcionam em áreas abertas com alcance de 500m',
  ],
  stibAdvantages: [
    'Experiência em eventos de alto padrão — sabemos que a apresentação visual importa tanto quanto o áudio',
    'Fones discretos e elegantes que não comprometem a estética do evento',
    'Montagem rápida e silenciosa que não interfere na decoração do Villa Bisutti',
    'Canais de áudio independentes para cada ambiente (salão, mezanino, lounge)',
    'Suporte técnico presente e discreto durante todo o evento',
    'Logística que respeita os protocolos de acesso e segurança das unidades premium',
  ],
  localKeywords: [
    'palestra silenciosa Villa Bisutti',
    'fones sem fio Vila Olímpia eventos',
    'silent conference Villa Bisutti SP',
    'eventos corporativos Vila Olímpia palestra silenciosa',
    'lançamento Villa Bisutti fones sem fio',
  ],
  faqs: [
    {
      question: 'A STIB já realizou eventos no Villa Bisutti?',
      answer:
        'Sim, a STIB atende eventos corporativos e lançamentos de produto nas unidades do Villa Bisutti, principalmente na Casa do Ator e Gomes de Carvalho. Nossa equipe entende o padrão premium do venue e adapta a montagem para preservar a estética e a decoração dos ambientes.',
    },
    {
      question: 'Os fones sem fio combinam com o ambiente sofisticado do Villa Bisutti?',
      answer:
        'Com certeza. Nossos fones têm design moderno e discreto, e a ausência de caixas de som e cabos visíveis valoriza ainda mais a decoração do Villa Bisutti. Para eventos onde a estética é prioridade, a palestra silenciosa é a solução ideal — áudio perfeito sem poluição visual.',
    },
    {
      question: 'A STIB atende todas as unidades do Villa Bisutti?',
      answer:
        'Sim, atendemos todas as unidades do Villa Bisutti na Vila Olímpia: Casa do Ator, Gomes de Carvalho e Tenerife. Cada unidade tem características específicas e nossa equipe adapta a configuração dos fones para cada espaço.',
    },
    {
      question: 'É possível usar palestra silenciosa no lounge externo do Tenerife?',
      answer:
        'Sim! Os fones RF da STIB funcionam perfeitamente em áreas abertas como o lounge externo da unidade Tenerife, com alcance de 500m. Isso permite que os participantes aproveitem o paisagismo e o coffee break sem perder a transmissão.',
    },
    {
      question: 'Qual o prazo para orçamento de evento no Villa Bisutti?',
      answer:
        'Recomendamos solicitar orçamento com pelo menos 2 semanas de antecedência para garantir disponibilidade. Para eventos de alto padrão com requisitos técnicos específicos, sugerimos 1 mês para planejamento detalhado e visita técnica prévia ao local.',
    },
  ],
  seoTitle:
    'Palestra Silenciosa Villa Bisutti | Fones Sem Fio para Eventos Premium em SP',
  seoDescription:
    'Palestra silenciosa no Villa Bisutti: aluguel de fones sem fio para eventos corporativos de alto padrão, lançamentos e convenções na Vila Olímpia, SP. Experiência premium e discreta. Orçamento!',
  heroImageSeq: 'venuevillabisuttihero',
  heroImageUrl: '/img/stib/cidade-sao-paulo.webp',
  mapEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3656.0!2d-46.6780!3d-23.5940!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDM1JzM4LjQiUyA0NsKwNDAnNDAuOCJX!5e0!3m2!1spt-BR!2sbr!4v1',
};

// ─── Venue 7: Tokio Marine Hall (antigo Tom Brasil) ──────────────────────

export const TOKIOMARINE_DATA: VenueData = {
  slug: 'palestra-silenciosa-tokio-marine-hall',
  name: 'Tokio Marine Hall',
  fullName: 'Tokio Marine Hall (antigo Tom Brasil) — São Paulo',
  website: 'tokiomarinehall.com.br',
  location: 'São Paulo, SP',
  address: 'Rua Bragança Paulista, 1281 — Várzea de Baixo, São Paulo, SP — CEP 04727-002',
  neighborhood: 'Várzea de Baixo (Zona Sul)',
  description:
    'O Tokio Marine Hall, antigo Tom Brasil e HSBC Brasil, é uma das casas de espetáculos mais emblemáticas de São Paulo. Com capacidade para 4.000 pessoas na pista, palco de 250m² com 22m de altura e 9m de boca de cena, o venue recebe shows nacionais e internacionais, peças de teatro, musicais, eventos corporativos de grande porte, formaturas e convenções. Sua infraestrutura técnica profissional e localização estratégica o tornam um dos espaços mais versáteis da capital.',
  capacity: 'Até 4.000 pessoas (pista)',
  area: 'Palco de 250m² com 22m de altura e 9m de boca de cena',
  parking: 'Estacionamento próprio no local',
  eventTypes: [
    'Convenções e congressos corporativos',
    'Lançamentos de produto em grande escala',
    'Formaturas e eventos acadêmicos',
    'Shows e espetáculos',
    'Feiras e exposições',
    'Eventos de entretenimento',
  ],
  features: [
    'Capacidade para 4.000 pessoas na pista',
    'Palco de 250m² com 22m de altura e boca de cena de 9m',
    'Infraestrutura técnica profissional (som, luz, projeção)',
    'Histórico de shows internacionais — acústica e estrutura testadas em grande escala',
    'Versatilidade para eventos corporativos, formaturas e espetáculos',
    'Localização estratégica na zona sul de São Paulo',
  ],
  whySilentLectureWorks: [
    'A capacidade de 4.000 pessoas na pista exige tecnologia de áudio que funcione perfeitamente em escala — os fones RF da STIB garantem qualidade uniforme do primeiro ao último participante',
    'O palco de 250m² com 22m de altura é ideal para projeções e telões — o áudio via fones permite que todos vejam e ouçam perfeitamente, independente da posição',
    'A versatilidade do Tokio Marine Hall (shows, corporativo, formatura) exige fornecedor que se adapte a diferentes formatos — a STIB configura os fones para cada tipo de evento',
    'A acústica profissional do venue potencializa a qualidade de áudio dos fones, criando uma experiência imersiva que som ambiente não consegue replicar',
    'Em eventos corporativos dentro de uma casa de shows, a palestra silenciosa mantém o foco profissional sem perder a atmosfera única do local',
  ],
  stibAdvantages: [
    'Experiência comprovada em eventos de grande escala — 5.000 fones disponíveis para o Tokio Marine Hall',
    'Fones RF com alcance de 500m cobrem toda a pista, mezanino e áreas de circulação',
    'Montagem que se integra à infraestrutura técnica profissional do venue',
    'Múltiplos canais de áudio para tradução simultânea ou trilhas de conteúdo paralelas',
    'Suporte técnico presencial durante toda a programação',
    'Logística otimizada para a zona sul de São Paulo',
  ],
  localKeywords: [
    'palestra silenciosa Tokio Marine Hall',
    'fones sem fio Tom Brasil eventos',
    'silent conference Tokio Marine Hall SP',
    'eventos corporativos Várzea de Baixo palestra silenciosa',
    'convenção Tokio Marine Hall fones sem fio',
  ],
  faqs: [
    {
      question: 'A STIB consegue atender um evento com 4.000 pessoas no Tokio Marine Hall?',
      answer:
        'Sim, o Tokio Marine Hall é um dos venues onde nossa capacidade de 5.000 fones brilha. Podemos atender a casa lotada com áudio de qualidade cristalina para todos os 4.000 participantes simultaneamente, com múltiplos canais de conteúdo se necessário.',
    },
    {
      question: 'É possível fazer palestra silenciosa no palco de 250m² do Tokio Marine Hall?',
      answer:
        'Sim, e é uma combinação perfeita. O palco de 250m² com 22m de altura e boca de cena de 9m permite projeções impactantes enquanto o áudio chega com qualidade impecável a cada fone, independente de onde o participante esteja — pista, mezanino ou camarote.',
    },
    {
      question: 'A STIB já realizou eventos no Tokio Marine Hall (antigo Tom Brasil)?',
      answer:
        'Sim, atendemos eventos corporativos de grande porte, formaturas e convenções no Tokio Marine Hall. Nossa equipe conhece a infraestrutura do venue, os pontos de energia para os transmissores e a melhor configuração para cobertura total da pista e demais áreas.',
    },
    {
      question: 'Os fones funcionam bem com a acústica de casa de shows?',
      answer:
        'Perfeitamente. A acústica profissional do Tokio Marine Hall foi projetada para shows e espetáculos, o que significa que o ambiente tem tratamento acústico de alta qualidade. Isso beneficia a transmissão RF dos nossos fones, resultando em áudio ainda mais limpo e definido.',
    },
    {
      question: 'Como funciona a logística de montagem no Tokio Marine Hall?',
      answer:
        'Nossa equipe chega com antecedência combinada com a administração do venue para acessar o backstage e os pontos técnicos. A montagem dos transmissores e a distribuição dos fones levam cerca de 1 hora para eventos de grande porte. Trabalhamos em coordenação com a equipe técnica da casa para garantir integração perfeita.',
    },
  ],
  seoTitle:
    'Palestra Silenciosa Tokio Marine Hall (Tom Brasil) | Fones Sem Fio para Grandes Eventos',
  seoDescription:
    'Palestra silenciosa no Tokio Marine Hall (antigo Tom Brasil): aluguel de fones sem fio para convenções, formaturas e eventos corporativos na zona sul de SP. Capacidade para 4.000 pessoas. Orçamento!',
  heroImageSeq: 'venuetokiomarinehero',
  heroImageUrl: '/img/stib/setor-entretenimento.webp',
  mapEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3656.0!2d-46.7170!3d-23.6450!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDM4JzQyLjAiUyA0NsKwNDMnMDEuMiJX!5e0!3m2!1spt-BR!2sbr!4v1',
};

// ════════════════════════════════════════════════════════════════════════════
// VENUES EM OUTRAS CAPITAIS
// ════════════════════════════════════════════════════════════════════════════

// ─── Venue 8: Riocentro (Rio de Janeiro) ──────────────────────────────────

export const RIOCENTRO_DATA: VenueData = {
  slug: 'palestra-silenciosa-riocentro',
  name: 'Riocentro',
  fullName: 'Riocentro — Rio de Janeiro',
  website: 'riocentro.com.br',
  location: 'Rio de Janeiro, RJ',
  address: 'Av. Salvador Allende, 6555 — Barra da Tijuca, Rio de Janeiro, RJ',
  neighborhood: 'Barra da Tijuca (Zona Oeste)',
  description:
    'O Riocentro é o maior e mais versátil centro de convenções da América Latina, localizado na Barra da Tijuca, Rio de Janeiro. Com 4 pavilhões independentes, hotel integrado (Lagune), anfiteatro para até 12.000 pessoas e 7.000 vagas de estacionamento, é o palco dos maiores congressos, feiras de negócios, shows e eventos corporativos do Brasil. Gerido pela GL events, referência mundial em organização de eventos.',
  capacity: 'Até 12.000 pessoas no anfiteatro',
  area: '4 pavilhões de exposição, área externa extensa',
  parking: '7.000 vagas de estacionamento',
  eventTypes: [
    'Congressos e conferências internacionais',
    'Feiras de negócios e exposições',
    'Convenções corporativas',
    'Shows e eventos de entretenimento',
    'Lançamentos de produto',
    'Eventos esportivos',
  ],
  features: [
    'Maior centro de convenções da América Latina',
    '4 pavilhões independentes com climatização',
    'Anfiteatro com capacidade para 12.000 pessoas',
    'Hotel Lagune integrado ao complexo',
    '7.000 vagas de estacionamento',
    'Gestão GL events — padrão internacional de qualidade',
    'Localização privilegiada na Barra da Tijuca',
  ],
  whySilentLectureWorks: [
    'Os 4 pavilhões independentes do Riocentro permitem dezenas de palestras simultâneas sem interferência — cada pavilhão opera canais de áudio independentes com fones RF',
    'A escala do Riocentro demanda tecnologia que funcione com milhares de participantes — a STIB tem 5.000 fones e alcance RF de 500m, ideal para os grandes pavilhões',
    'Eventos internacionais frequentes no Riocentro exigem tradução simultânea em múltiplos idiomas — os fones eliminam cabines de tradução tradicionais e permitem que o participante escolha o idioma no próprio fone',
    'A área externa e os corredores de circulação entre pavilhões são cobertos pelo sinal RF — participantes podem se deslocar sem perder o áudio',
    'O anfiteatro de 12.000 lugares é perfeito para palestras magnas — o áudio via fones garante clareza uniforme para todos, independente da posição',
  ],
  stibAdvantages: [
    'Capacidade para eventos de escala internacional no Riocentro (até 5.000 fones simultâneos)',
    'Fones RF com alcance de 500m cobrem todos os pavilhões e áreas de circulação',
    'Tradução simultânea sem cabine — essencial para congressos internacionais no Riocentro',
    'Equipe técnica que conhece a logística de eventos de grande porte no Rio de Janeiro',
    'Montagem coordenada com a equipe GL events do Riocentro',
    'Logística interestadual otimizada para a Barra da Tijuca e zona oeste carioca',
  ],
  localKeywords: [
    'palestra silenciosa Riocentro',
    'fones sem fio Riocentro Rio de Janeiro',
    'silent conference Riocentro Barra',
    'eventos corporativos Barra da Tijuca palestra silenciosa',
    'congresso Riocentro fones sem fio',
  ],
  faqs: [
    {
      question: 'A STIB atende eventos no Riocentro, Rio de Janeiro?',
      answer:
        'Sim! A STIB atende eventos de todos os portes no Riocentro, no Rio de Janeiro. Nossa logística interestadual cobre a capital fluminense com entrega de equipamentos, equipe técnica dedicada e suporte presencial durante toda a programação. Atendemos desde congressos no anfiteatro até feiras com múltiplos pavilhões simultâneos.',
    },
    {
      question: 'Quantos fones a STIB consegue fornecer para um congresso no Riocentro?',
      answer:
        'A STIB tem capacidade para fornecer até 5.000 fones sem fio para eventos no Riocentro. Para o anfiteatro de 12.000 lugares, dependendo da ocupação prevista, podemos dimensionar o estoque necessário. Consulte-nos para eventos com mais de 5.000 participantes — temos soluções escaláveis.',
    },
    {
      question: 'Como funciona a logística da STIB para eventos no Rio de Janeiro?',
      answer:
        'A STIB gerencia toda a logística interestadual: equipamentos são transportados com antecedência, a equipe técnica se desloca para o Rio e coordena a montagem diretamente com a administração do Riocentro. Oferecemos suporte presencial durante todo o evento e retirada dos equipamentos após o encerramento.',
    },
    {
      question: 'É possível fazer tradução simultânea com os fones da STIB no Riocentro?',
      answer:
        'Sim, e é uma das soluções mais utilizadas em congressos internacionais no Riocentro. Os fones permitem múltiplos canais de idioma — o participante seleciona português, inglês, espanhol ou qualquer outro idioma direto no fone, eliminando a necessidade de cabines de tradução tradicionais e reduzindo custos operacionais.',
    },
    {
      question: 'Com quanta antecedência devo solicitar orçamento para evento no Riocentro?',
      answer:
        'Para eventos no Riocentro, recomendamos solicitar orçamento com pelo menos 3 semanas de antecedência. Para congressos internacionais ou eventos com mais de 2.000 participantes, o ideal é 1 mês, permitindo planejamento logístico detalhado e visita técnica prévia se necessária.',
    },
  ],
  seoTitle:
    'Palestra Silenciosa Riocentro Rio de Janeiro | Fones Sem Fio para Grandes Eventos',
  seoDescription:
    'Palestra silenciosa no Riocentro: aluguel de fones sem fio para congressos, feiras e eventos corporativos na Barra da Tijuca, RJ. Maior centro de convenções da América Latina. Orçamento!',
  heroImageSeq: 'venueriocentrohero',
  heroImageUrl: '/img/stib/cidade-rio.webp',
  mapEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3672.0!2d-43.4140!3d-22.9750!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjLCsDU4JzMwLjAiUyA0M8KwMjQnNTAuNCJX!5e0!3m2!1spt-BR!2sbr!4v1',
};

// ─── Venue 9: Centro de Convenções SulAmérica (RJ) ────────────────────────

export const SULAMERICA_DATA: VenueData = {
  slug: 'palestra-silenciosa-sulamerica-rj',
  name: 'Centro de Convenções SulAmérica',
  fullName: 'Centro de Convenções SulAmérica — Rio de Janeiro',
  website: 'ccsulamerica.com.br',
  location: 'Rio de Janeiro, RJ',
  address: 'Av. Paulo de Frontin, 1 — Cidade Nova, Rio de Janeiro, RJ',
  neighborhood: 'Cidade Nova (Centro)',
  description:
    'O Centro de Convenções SulAmérica está estrategicamente localizado no coração do Rio de Janeiro, na Cidade Nova, com acesso integrado ao metrô e fácil ligação com o Aeroporto Santos Dumont. Com auditórios modernos para até 5.000 pessoas, salas modulares e infraestrutura tecnológica completa, é o venue ideal para eventos corporativos, congressos, seminários e feiras de negócios no centro da capital fluminense.',
  capacity: 'Até 5.000 pessoas em auditório',
  area: 'Salas modulares e auditórios múltiplos',
  parking: 'Estacionamento próprio com acesso facilitado',
  eventTypes: [
    'Congressos e seminários',
    'Eventos corporativos',
    'Convenções de vendas',
    'Feiras de negócios',
    'Lançamentos de produto',
    'Palestras e workshops',
  ],
  features: [
    'Localização central na Cidade Nova com acesso ao metrô',
    'Auditórios modernos com capacidade de até 5.000 pessoas',
    'Salas modulares para eventos simultâneos de diferentes portes',
    'Infraestrutura tecnológica completa (som, luz, projeção)',
    'Fácil acesso ao Aeroporto Santos Dumont',
    'Região com ampla oferta de hotéis e restaurantes',
  ],
  whySilentLectureWorks: [
    'Os auditórios modulares do SulAmérica permitem múltiplas sessões simultâneas — a palestra silenciosa garante zero interferência entre salas adjacentes',
    'A localização central atrai participantes de todo o Rio — os fones sem fio garantem experiência de áudio premium independente do tamanho do auditório',
    'Eventos no centro do Rio exigem fornecedor com logística eficiente — a STIB opera com equipe dedicada e entrega programada no venue',
    'As salas modulares permitem programação flexível — os canais RF independentes se adaptam a qualquer configuração de layout',
    'Para eventos corporativos com múltiplas trilhas de conteúdo, os fones permitem que participantes transitem entre salas sem perder a transmissão',
  ],
  stibAdvantages: [
    'Experiência em eventos corporativos no centro do Rio de Janeiro',
    'Fones RF com alcance de 500m cobrem todos os auditórios e áreas comuns',
    'Tradução simultânea integrada nos fones — sem necessidade de cabines',
    'Montagem rápida que respeita os horários de programação do SulAmérica',
    'Suporte técnico presencial durante todo o evento',
    'Logística otimizada para o centro do Rio e Cidade Nova',
  ],
  localKeywords: [
    'palestra silenciosa SulAmérica Rio',
    'fones sem fio Cidade Nova eventos',
    'silent conference centro Rio de Janeiro',
    'eventos corporativos SulAmérica palestra silenciosa',
    'congresso Cidade Nova fones sem fio',
  ],
  faqs: [
    {
      question: 'A STIB atende eventos no Centro de Convenções SulAmérica, no Rio?',
      answer:
        'Sim, a STIB atende regularmente eventos corporativos e congressos no Centro de Convenções SulAmérica, na Cidade Nova. Nossa equipe coordena a logística interestadual e a montagem diretamente com a administração do venue, garantindo operação impecável no coração do Rio de Janeiro.',
    },
    {
      question: 'O acesso ao SulAmérica é fácil para a equipe técnica da STIB?',
      answer:
        'Sim. O Centro de Convenções SulAmérica tem localização privilegiada na Cidade Nova, com acesso integrado ao metrô e próximo ao Aeroporto Santos Dumont. Nossa equipe utiliza o acesso de serviço para descarregar equipamentos diretamente no local de montagem.',
    },
    {
      question: 'Quantos participantes a STIB consegue atender no auditório do SulAmérica?',
      answer:
        'A STIB pode atender a lotação completa do auditório principal do SulAmérica, com capacidade para até 5.000 participantes simultâneos. Nossos 5.000 fones em estoque garantem cobertura total para o maior auditório do venue.',
    },
    {
      question: 'É possível usar palestra silenciosa em eventos menores nas salas modulares?',
      answer:
        'Sim, e é uma das configurações mais comuns. As salas modulares do SulAmérica são perfeitas para palestra silenciosa — cada sala opera com canais independentes, permitindo múltiplas sessões simultâneas sem interferência. Atendemos desde salas para 50 pessoas até o auditório principal.',
    },
    {
      question: 'Qual o prazo de antecedência para evento no SulAmérica?',
      answer:
        'Recomendamos 2 semanas de antecedência para eventos no SulAmérica. Como envolve logística interestadual, esse prazo garante planejamento adequado de transporte, equipe técnica e configuração dos equipamentos.',
    },
  ],
  seoTitle:
    'Palestra Silenciosa Centro de Convenções SulAmérica RJ | Fones Sem Fio para Eventos',
  seoDescription:
    'Palestra silenciosa no Centro de Convenções SulAmérica, Rio de Janeiro: aluguel de fones sem fio para congressos e eventos corporativos na Cidade Nova. Auditório para 5.000 pessoas. Orçamento!',
  heroImageSeq: 'venuesulamericariodejaneirohero',
  heroImageUrl: '/img/stib/cidade-rio.webp',
  mapEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3674.0!2d-43.2120!3d-22.9100!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjLCsDU0JzM2LjAiUyA0M8KwMTInNDMuMiJX!5e0!3m2!1spt-BR!2sbr!4v1',
};

// ─── Venue 10: Expominas BH ─────────────────────────────────────────────────

export const EXPOMINAS_DATA: VenueData = {
  slug: 'palestra-silenciosa-expominas-bh',
  name: 'Expominas BH',
  fullName: 'Expominas — Belo Horizonte',
  website: 'expominas.com.br',
  location: 'Belo Horizonte, MG',
  address: 'Av. Amazonas, 6200 — Gameleira, Belo Horizonte, MG',
  neighborhood: 'Gameleira',
  description:
    'O Expominas é o maior e mais conceituado centro de convenções de Minas Gerais, localizado no bairro Gameleira, em Belo Horizonte. Com pavilhões de exposição de grande porte, auditórios modulares, infraestrutura completa de som e projeção, e localização estratégica com fácil acesso às principais vias da capital mineira, o Expominas sedia feiras de negócios, congressos, shows e eventos corporativos de proporção estadual e nacional.',
  capacity: 'Pavilhões e auditórios modulares de grande porte',
  area: 'Área construída extensa com múltiplos pavilhões',
  parking: 'Estacionamento amplo no complexo',
  eventTypes: [
    'Feiras de negócios e exposições',
    'Congressos e convenções',
    'Eventos corporativos',
    'Shows e eventos culturais',
    'Lançamentos de produto',
    'Feiras agropecuárias e industriais',
  ],
  features: [
    'Maior centro de convenções de Minas Gerais',
    'Pavilhões de exposição modulares e climatizados',
    'Auditórios com infraestrutura técnica profissional',
    'Localização estratégica na Av. Amazonas, Gameleira',
    'Fácil acesso às principais vias de BH e região metropolitana',
    'Estacionamento amplo para expositores e visitantes',
  ],
  whySilentLectureWorks: [
    'Os múltiplos pavilhões do Expominas permitem feiras com dezenas de estandes — a palestra silenciosa dentro de cada estande cria ilhas de conteúdo sem poluição sonora',
    'A escala dos eventos no Expominas (feiras agropecuárias, congressos estaduais) exige tecnologia robusta — os fones RF da STIB operam com estabilidade mesmo em ambientes com milhares de pessoas',
    'Eventos simultâneos nos pavilhões e auditórios são comuns no Expominas — cada espaço opera canais de áudio independentes sem interferência',
    'A localização em BH facilita a logística da STIB a partir de São Paulo — rodovias como Fernão Dias e BR-381 permitem entrega rápida dos equipamentos',
    'Congressos mineiros com múltiplas trilhas de conteúdo se beneficiam da flexibilidade dos fones — participantes escolhem a palestra sem trocar de sala',
  ],
  stibAdvantages: [
    'Experiência em eventos de grande porte — ideal para a escala do Expominas',
    'Fones RF com alcance de 500m cobrem pavilhões, auditórios e áreas de circulação',
    'Logística interestadual otimizada: SP → BH via principais rodovias',
    'Montagem rápida e suporte técnico presencial durante todo o evento',
    'Múltiplos canais de áudio para feiras com palestras simultâneas em estandes',
    'Equipe técnica dedicada que acompanha o evento do início ao fim em BH',
  ],
  localKeywords: [
    'palestra silenciosa Expominas BH',
    'fones sem fio Expominas Belo Horizonte',
    'silent conference Expominas Minas Gerais',
    'eventos corporativos Gameleira palestra silenciosa',
    'feira Expominas fones sem fio',
  ],
  faqs: [
    {
      question: 'A STIB atende eventos no Expominas, em Belo Horizonte?',
      answer:
        'Sim, a STIB atende eventos de todos os portes no Expominas, em Belo Horizonte. Nossa logística interestadual cobre a capital mineira com entrega programada, equipe técnica dedicada e suporte presencial durante toda a programação. Atendemos desde congressos nos auditórios até feiras com múltiplos estandes.',
    },
    {
      question: 'Como funciona a logística de SP para Belo Horizonte?',
      answer:
        'A logística é feita por rodovia (Fernão Dias ou BR-381) com antecedência. Os equipamentos chegam ao Expominas no dia anterior ou na manhã do evento, dependendo da complexidade. Nossa equipe técnica se desloca para BH e coordena a montagem diretamente no venue.',
    },
    {
      question: 'A STIB consegue atender feiras com palestras simultâneas em múltiplos estandes?',
      answer:
        'Sim, e é uma das configurações mais inteligentes para feiras no Expominas. Cada estande que oferece palestra recebe um canal de áudio independente, criando ilhas de conteúdo sem ruído. Os visitantes circulam livremente e ouvem apenas o estande em que estão.',
    },
    {
      question: 'Qual o custo adicional para eventos em BH comparado a SP?',
      answer:
        'O custo adicional refere-se basicamente à logística de transporte e deslocamento da equipe (diárias e deslocamento). Para eventos de maior porte, o custo logístico se dilui e fica bastante competitivo. Solicite um orçamento personalizado para seu evento no Expominas.',
    },
    {
      question: 'Com quanta antecedência preciso reservar para evento no Expominas?',
      answer:
        'Recomendamos 3 semanas de antecedência para eventos no Expominas, considerando a logística interestadual. Para feiras de grande porte ou eventos que demandam mais de 1.000 fones, o ideal é 1 mês para planejamento completo.',
    },
  ],
  seoTitle:
    'Palestra Silenciosa Expominas BH | Fones Sem Fio para Feiras e Eventos em Minas',
  seoDescription:
    'Palestra silenciosa no Expominas Belo Horizonte: aluguel de fones sem fio para feiras, congressos e eventos corporativos em MG. Maior centro de convenções mineiro. Orçamento!',
  heroImageSeq: 'venueexpominasbhhero',
  heroImageUrl: '/img/stib/setor-feira.webp',
  mapEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3750.0!2d-43.9950!3d-19.9200!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDU1JzEyLjAiUyA0M8KwNTknNDIuMCJX!5e0!3m2!1spt-BR!2sbr!4v1',
};

// ─── Venue 11: Minascentro BH ──────────────────────────────────────────────

export const MINASCENTRO_DATA: VenueData = {
  slug: 'palestra-silenciosa-minascentro-bh',
  name: 'Minascentro',
  fullName: 'Minascentro — Belo Horizonte',
  website: 'minascentro.com.br',
  location: 'Belo Horizonte, MG',
  address: 'Av. Augusto de Lima, 785 — Centro, Belo Horizonte, MG',
  neighborhood: 'Centro',
  description:
    'O Minascentro é um dos espaços de eventos mais emblemáticos de Belo Horizonte, instalado em um prédio histórico no coração da capital mineira. Com capacidade para mais de 8.000 pessoas simultâneas, o venue combina charme arquitetônico com infraestrutura moderna: auditórios, salas de reunião, teatro e espaços expositivos modulares. É o local ideal para congressos, convenções corporativas, feiras técnicas e eventos culturais no centro de BH.',
  capacity: 'Mais de 8.000 pessoas simultâneas',
  area: 'Múltiplos auditórios, teatro e espaços expositivos',
  parking: 'Estacionamentos conveniados na região central',
  eventTypes: [
    'Congressos e convenções',
    'Eventos corporativos',
    'Feiras técnicas e exposições',
    'Seminários e palestras',
    'Eventos culturais e artísticos',
    'Formaturas e eventos acadêmicos',
  ],
  features: [
    'Capacidade para mais de 8.000 pessoas simultâneas',
    'Prédio histórico com arquitetura tombada',
    'Auditórios modernos com tratamento acústico',
    'Teatro integrado com infraestrutura cênica completa',
    'Salas de reunião modulares para eventos paralelos',
    'Localização central — fácil acesso de toda a Grande BH',
  ],
  whySilentLectureWorks: [
    'O charme histórico do Minascentro é valorizado pela ausência de equipamentos de som visíveis — os fones sem fio preservam a estética do prédio',
    'Múltiplos auditórios e salas permitem programação simultânea — a palestra silenciosa garante que cada sala opere com áudio independente sem vazamento sonoro',
    'O teatro do Minascentro tem acústica excelente — os fones RF potencializam essa qualidade para uma experiência imersiva',
    'Eventos no centro de BH atraem público diverso — a palestra silenciosa permite múltiplos idiomas e trilhas de conteúdo no mesmo espaço',
    'A logística a partir de SP é facilitada pelo acesso ao centro de BH — entrega programada e montagem coordenada com a administração do Minascentro',
  ],
  stibAdvantages: [
    'Experiência em eventos em espaços históricos — montagem que preserva o patrimônio',
    'Fones discretos e elegantes que não competem com a arquitetura do Minascentro',
    'Canais de áudio independentes para auditórios, teatro e salas simultâneas',
    'Tradução simultânea integrada nos fones para congressos com participantes internacionais',
    'Logística SP → BH otimizada para o centro da capital mineira',
    'Suporte técnico presente e discreto durante toda a programação',
  ],
  localKeywords: [
    'palestra silenciosa Minascentro BH',
    'fones sem fio Minascentro Belo Horizonte',
    'silent conference Minascentro centro BH',
    'eventos corporativos centro BH palestra silenciosa',
    'congresso Minascentro fones sem fio',
  ],
  faqs: [
    {
      question: 'A STIB atende eventos no Minascentro, centro de BH?',
      answer:
        'Sim, a STIB atende eventos no Minascentro, no centro de Belo Horizonte. Nossa equipe coordena a logística de SP para BH e monta os equipamentos respeitando as características do prédio histórico. Já realizamos congressos, convenções e eventos corporativos no Minascentro.',
    },
    {
      question: 'Os fones da STIB funcionam bem no teatro do Minascentro?',
      answer:
        'Perfeitamente. O teatro do Minascentro tem acústica tratada que potencializa a qualidade dos nossos fones RF. A experiência é cinematográfica — os participantes ouvem cada palavra com clareza absoluta, independente da posição na plateia.',
    },
    {
      question: 'É possível usar palestra silenciosa em eventos simultâneos nos auditórios?',
      answer:
        'Sim, e é uma das configurações mais vantajosas no Minascentro. Com múltiplos auditórios e salas, cada espaço recebe seu próprio canal de áudio. Os participantes podem transitar entre sessões sem interferência — cada sala é acusticamente independente.',
    },
    {
      question: 'Como é o acesso para descarregar equipamentos no centro de BH?',
      answer:
        'Coordenamos previamente com a administração do Minascentro para utilizar o acesso de serviço. A logística é planejada para horários de menor movimento no centro de BH, garantindo descarregamento rápido e sem transtornos.',
    },
    {
      question: 'Vale a pena trazer a STIB de SP para um evento em BH?',
      answer:
        'Vale muito. A STIB é referência nacional em palestra silenciosa, e nossa tecnologia RF é superior às alternativas locais. O custo da logística interestadual se justifica pela qualidade do equipamento, experiência da equipe e tranquilidade de ter um fornecedor premium gerenciando o áudio do seu evento.',
    },
  ],
  seoTitle:
    'Palestra Silenciosa Minascentro BH | Fones Sem Fio para Congressos e Eventos',
  seoDescription:
    'Palestra silenciosa no Minascentro Belo Horizonte: aluguel de fones sem fio para congressos, convenções e eventos corporativos no centro de BH. Capacidade para 8.000 pessoas. Orçamento!',
  heroImageSeq: 'venueminascentrobhhero',
  heroImageUrl: '/img/stib/local-convencoes-int.webp',
  mapEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3751.0!2d-43.9400!3d-19.9200!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDU1JzEyLjAiUyA0M8KwNTYnMjQuMCJX!5e0!3m2!1spt-BR!2sbr!4v1',
};

// ─── Venue 12: Brasil 21 (Brasília) ──────────────────────────────────────

export const BRASIL21_DATA: VenueData = {
  slug: 'palestra-silenciosa-brasil-21',
  name: 'Brasil 21',
  fullName: 'Complexo Brasil 21 — Brasília',
  website: 'brasil21.com.br',
  location: 'Brasília, DF',
  address: 'SHS Quadra 06, Conjunto A, Bloco E — Asa Sul, Brasília, DF — CEP 70316-000',
  neighborhood: 'Asa Sul (Plano Piloto)',
  description:
    'O Complexo Brasil 21 é um dos empreendimentos mais completos de Brasília, reunindo centro de convenções, hotel cinco estrelas, centro empresarial e shopping em um único complexo na Asa Sul. Com auditórios modernos, salas modulares e infraestrutura de padrão internacional, é o venue ideal para congressos, convenções corporativas, eventos governamentais e conferências de alto nível na capital federal.',
  capacity: 'Auditórios de 50 a 1.500 lugares',
  area: 'Complexo multiuso com centro de convenções e hotel integrado',
  parking: 'Estacionamento amplo no complexo',
  eventTypes: [
    'Congressos e convenções',
    'Eventos corporativos',
    'Conferências governamentais',
    'Seminários e workshops',
    'Eventos diplomáticos',
    'Lançamentos de produto',
  ],
  features: [
    'Centro de convenções integrado ao hotel cinco estrelas',
    'Auditórios modulares com tecnologia audiovisual de ponta',
    'Salas de reunião flexíveis para eventos de diferentes portes',
    'Complexo empresarial no mesmo local',
    'Shopping center integrado',
    'Localização estratégica na Asa Sul, próximo ao Eixo Monumental',
  ],
  whySilentLectureWorks: [
    'O Brasil 21 recebe frequentemente congressos com múltiplas trilhas simultâneas — a palestra silenciosa garante que cada sala opere com áudio independente e sem interferência',
    'A proximidade com o hotel permite que participantes transitem entre hospedagem e evento sem perder a transmissão — os fones RF cobrem todo o complexo',
    'Eventos governamentais e diplomáticos no Brasil 21 se beneficiam da tradução simultânea sem cabine — economia de espaço e elegância na operação',
    'As salas modulares permitem programação flexível — os canais independentes se adaptam a qualquer layout',
    'O ambiente premium do Brasil 21 é valorizado pela ausência de equipamentos de som visíveis — estética limpa e profissional',
  ],
  stibAdvantages: [
    'Experiência comprovada em eventos corporativos e governamentais no Brasil 21',
    'Fones RF com alcance de 500m cobrem auditórios, salas modulares e áreas do hotel',
    'Tradução simultânea integrada — até 10 idiomas sem cabine física',
    'Montagem coordenada com a administração do complexo',
    'Suporte técnico presencial do setup ao encerramento',
    'Logística otimizada para a Asa Sul e Plano Piloto',
  ],
  localKeywords: [
    'palestra silenciosa Brasil 21 Brasília',
    'fones sem fio Brasil 21 eventos',
    'silent conference Brasil 21 DF',
    'eventos corporativos Asa Sul palestra silenciosa',
    'congresso Brasil 21 fones sem fio',
  ],
  faqs: [
    {
      question: 'A STIB atende eventos no Complexo Brasil 21, em Brasília?',
      answer:
        'Sim, a STIB atende regularmente eventos corporativos e congressos no Complexo Brasil 21, na Asa Sul. Nossa logística interestadual cobre a capital federal com entrega programada, equipe técnica dedicada e suporte presencial durante toda a programação.',
    },
    {
      question: 'Os fones funcionam nos auditórios e também no hotel do Brasil 21?',
      answer:
        'Sim, os fones RF da STIB têm alcance de 500m, cobrindo o centro de convenções, áreas de circulação e o hotel integrado. Participantes hospedados podem transitar entre os espaços sem perder o áudio.',
    },
    {
      question: 'Quantos participantes a STIB consegue atender no Brasil 21?',
      answer:
        'A STIB tem capacidade para atender a lotação completa dos auditórios do Brasil 21, com até 5.000 fones simultâneos. Para o maior auditório (1.500 lugares), oferecemos cobertura total com múltiplos canais de áudio.',
    },
    {
      question: 'A STIB oferece tradução simultânea para eventos internacionais no Brasil 21?',
      answer:
        'Sim, e é uma das soluções mais utilizadas. Os fones permitem até 10 idiomas simultâneos — o participante seleciona o idioma no próprio fone. Ideal para congressos com delegações internacionais e eventos diplomáticos no Brasil 21.',
    },
    {
      question: 'Qual o prazo para orçamento de evento no Brasil 21?',
      answer:
        'Recomendamos 3 semanas de antecedência. Para congressos com mais de 500 participantes ou eventos que demandam múltiplos idiomas, o ideal é 1 mês para planejamento detalhado da logística SP-Brasília.',
    },
  ],
  seoTitle:
    'Palestra Silenciosa Brasil 21 Brasília | Fones Sem Fio para Congressos e Eventos',
  seoDescription:
    'Palestra silenciosa no Complexo Brasil 21 em Brasília: aluguel de fones sem fio para congressos, convenções e eventos corporativos na Asa Sul, DF. Hotel integrado. Orçamento!',
  heroImageSeq: 'venuebrasil21bsbhero',
  heroImageUrl: '/img/stib/local-auditorio.webp',
  mapEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3839.0!2d-47.8880!3d-15.8100!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTXCsDQ4JzM2LjAiUyA0N8KwNTMnMTYuOCJX!5e0!3m2!1spt-BR!2sbr!4v1',
};

// ─── Venue 13: Espaço Dois Ipês (Brasília) ──────────────────────────────

export const DOISIPES_DATA: VenueData = {
  slug: 'palestra-silenciosa-espaco-dois-ipes',
  name: 'Espaço Dois Ipês',
  fullName: 'Espaço Dois Ipês — Brasília',
  website: 'espacodoisipes.com.br',
  location: 'Brasília, DF',
  address: 'SMPW Trecho 02, Conjunto 08 — Park Way, Brasília, DF — CEP 71745-508',
  neighborhood: 'Park Way (Zona Sul)',
  description:
    'O Espaço Dois Ipês é um dos venues de eventos mais charmosos de Brasília, localizado em meio à natureza no bairro Park Way. Com salão principal versátil, área externa arborizada com jardins, estacionamento amplo e estrutura modular, o espaço é ideal para eventos corporativos, casamentos, formaturas, workshops e confraternizações em um ambiente sofisticado e acolhedor na capital federal.',
  capacity: 'Até 600 pessoas no salão principal',
  area: 'Salão principal com área externa ajardinada',
  parking: 'Estacionamento amplo e privativo no local',
  eventTypes: [
    'Eventos corporativos',
    'Workshops e treinamentos',
    'Confraternizações empresariais',
    'Formaturas',
    'Casamentos e eventos sociais',
    'Lançamentos de produto',
  ],
  features: [
    'Ambiente ao ar livre integrado à natureza do Park Way',
    'Salão principal versátil com climatização',
    'Área externa com jardins paisagísticos e dois ipês centenários',
    'Estrutura modular que se adapta a diferentes formatos de evento',
    'Estacionamento amplo e privativo',
    'Cozinha industrial de apoio para catering',
  ],
  whySilentLectureWorks: [
    'O Espaço Dois Ipês tem um ambiente natural com acústica aberta — a palestra silenciosa resolve o desafio de áudio em espaços externos, eliminando ruído ambiente e dispersão sonora',
    'A área externa arborizada permite coffee breaks e networking sem perder a transmissão — os fones RF funcionam perfeitamente em áreas abertas com alcance de 500m',
    'Workshops e treinamentos corporativos no Espaço Dois Ipês se beneficiam da divisão em grupos com canais de áudio independentes',
    'A estética natural e elegante do espaço é preservada — sem caixas de som ou cabos visíveis que comprometeriam a decoração',
    'O estacionamento amplo facilita a logística de entrega e retirada dos equipamentos da STIB',
  ],
  stibAdvantages: [
    'Fones discretos e elegantes para ambientes sofisticados como o Dois Ipês',
    'Canais de áudio independentes para múltiplas atividades simultâneas (palestra + workshop + área externa)',
    'Tecnologia RF com alcance de 500m cobrindo salão e jardins',
    'Montagem rápida e silenciosa que não interfere na decoração do espaço',
    'Suporte técnico presente e discreto durante todo o evento',
    'Logística otimizada para o Park Way e zona sul de Brasília',
  ],
  localKeywords: [
    'palestra silenciosa Espaço Dois Ipês Brasília',
    'fones sem fio Park Way eventos',
    'silent conference Dois Ipês DF',
    'eventos corporativos Park Way palestra silenciosa',
    'workshop Espaço Dois Ipês fones sem fio',
  ],
  faqs: [
    {
      question: 'A STIB atende eventos no Espaço Dois Ipês, Park Way?',
      answer:
        'Sim, a STIB atende eventos no Espaço Dois Ipês, no Park Way. Nossa equipe coordena a logística interestadual e monta os equipamentos respeitando o ambiente natural e a estrutura do espaço. Já realizamos workshops, treinamentos e eventos corporativos no local.',
    },
    {
      question: 'Os fones funcionam bem na área externa ajardinada?',
      answer:
        'Perfeitamente. Nossos fones RF operam com alcance de 500m em áreas abertas, cobrindo o salão principal e toda a área externa ajardinada do Espaço Dois Ipês. Os participantes podem circular livremente entre os ambientes sem perder a transmissão.',
    },
    {
      question: 'É possível fazer workshops simultâneos no Espaço Dois Ipês?',
      answer:
        'Sim, e é uma configuração muito comum. Dividimos o espaço em estações ou grupos com canais de áudio independentes. Cada grupo ouve apenas seu facilitador, sem interferência dos demais — ideal para dinâmicas corporativas e treinamentos.',
    },
    {
      question: 'Qual o tempo de montagem no Espaço Dois Ipês?',
      answer:
        'A montagem leva de 30 a 45 minutos, dependendo do número de canais e participantes. Nossa equipe chega com antecedência para configurar os transmissores e realizar testes de alcance em todos os ambientes (salão e jardins).',
    },
    {
      question: 'A STIB já realizou eventos de que tipo no Espaço Dois Ipês?',
      answer:
        'Já atendemos workshops corporativos, treinamentos de equipe, confraternizações empresariais e eventos de lançamento no Espaço Dois Ipês. O formato de palestra silenciosa combina perfeitamente com o ambiente sofisticado e natural do local.',
    },
  ],
  seoTitle:
    'Palestra Silenciosa Espaço Dois Ipês Brasília | Fones Sem Fio para Eventos',
  seoDescription:
    'Palestra silenciosa no Espaço Dois Ipês em Brasília: aluguel de fones sem fio para workshops, treinamentos e eventos corporativos no Park Way, DF. Ambiente natural e sofisticado. Orçamento!',
  heroImageSeq: 'venuedoisipesbsbhero',
  heroImageUrl: '/img/stib/local-teatro.webp',
  mapEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3838.0!2d-47.9600!3d-15.8700!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTXCsDUyJzEyLjAiUyA0N8KwNTcnMzYuMCJX!5e0!3m2!1spt-BR!2sbr!4v1',
};

// ─── Venue 14: Arena Mané Garrincha (Brasília) ───────────────────────────

export const MANEGARRINCHA_DATA: VenueData = {
  slug: 'palestra-silenciosa-arena-mane-garrincha',
  name: 'Arena Mané Garrincha',
  fullName: 'Estádio Nacional Mané Garrincha — Brasília',
  website: 'arenamanegarrincha.com.br',
  location: 'Brasília, DF',
  address: 'SRPN — Eixo Monumental, Brasília, DF — CEP 70070-701',
  neighborhood: 'Eixo Monumental (Plano Piloto)',
  description:
    'O Estádio Nacional de Brasília Mané Garrincha é um dos maiores e mais modernos complexos multiuso do Brasil, localizado no coração do Eixo Monumental. Além de jogos de futebol, o Mané Garrincha sedia megaeventos, congressos, feiras, shows internacionais e convenções corporativas de grande porte. Com estrutura de arena coberta com capacidade para milhares de pessoas, áreas vip, salões modulares e estacionamento para 3.000 veículos, é o palco dos maiores eventos da capital federal.',
  capacity: 'Milhares de pessoas na arena coberta',
  area: 'Arena coberta com salões modulares e áreas vip',
  parking: '3.000 vagas de estacionamento',
  eventTypes: [
    'Congressos e convenções de grande porte',
    'Megaeventos e feiras',
    'Shows e espetáculos',
    'Eventos corporativos massivos',
    'Conferências governamentais',
    'Eventos esportivos e culturais',
  ],
  features: [
    'Arena coberta com capacidade para milhares de pessoas',
    'Salões modulares flexíveis para eventos simultâneos',
    'Áreas vip e camarotes corporativos',
    'Infraestrutura técnica profissional de nível internacional',
    'Localização privilegiada no Eixo Monumental de Brasília',
    '3.000 vagas de estacionamento',
    'Acessibilidade completa e múltiplos acessos',
  ],
  whySilentLectureWorks: [
    'A escala massiva da Arena Mané Garrincha exige tecnologia de áudio que funcione para milhares de pessoas — os fones RF da STIB garantem qualidade uniforme do primeiro ao último participante',
    'Eventos simultâneos nos salões modulares são comuns no Mané Garrincha — a palestra silenciosa permite múltiplas sessões independentes sem vazamento de áudio entre espaços',
    'A acústica de arena coberta é desafiadora para som tradicional (eco, reverberação) — os fones eliminam totalmente esse problema, entregando áudio cristalino via RF',
    'Congressos de grande porte no Mané Garrincha se beneficiam da tradução simultânea nos fones — múltiplos idiomas sem cabines físicas',
    'A logística de SP para Brasília é otimizada com estacionamento de 3.000 vagas e múltiplos acessos de serviço para descarregamento',
  ],
  stibAdvantages: [
    'Capacidade massiva: até 5.000 fones simultâneos para megaeventos na Arena',
    'Fones RF com alcance de 500m cobrem arena, salões e áreas de circulação',
    'Tradução simultânea sem cabine para congressos internacionais',
    'Equipe técnica especializada em eventos de grande escala',
    'Montagem coordenada com a administração do estádio',
    'Logística SP → Brasília com planejamento completo',
  ],
  localKeywords: [
    'palestra silenciosa Arena Mané Garrincha',
    'fones sem fio Estádio Nacional Brasília',
    'silent conference Mané Garrincha DF',
    'eventos corporativos Eixo Monumental palestra silenciosa',
    'congresso Arena Mané Garrincha fones sem fio',
  ],
  faqs: [
    {
      question: 'A STIB atende eventos na Arena Mané Garrincha?',
      answer:
        'Sim, a STIB atende eventos de qualquer porte no Estádio Nacional Mané Garrincha. Nossa logística interestadual cobre Brasília com entrega, montagem e suporte técnico dedicado para congressos, convenções e megaeventos na arena.',
    },
    {
      question: 'Quantos fones a STIB consegue fornecer para um evento no Mané Garrincha?',
      answer:
        'A STIB tem capacidade para fornecer até 5.000 fones sem fio simultâneos para eventos no Mané Garrincha. Para eventos com mais de 5.000 participantes, temos soluções escaláveis — consulte nossa equipe para dimensionamento personalizado.',
    },
    {
      question: 'Os fones funcionam bem em uma arena coberta tão grande?',
      answer:
        'Excelente pergunta. A tecnologia RF dos nossos fones foi projetada exatamente para ambientes como o Mané Garrincha. Posicionamos múltiplos transmissores estrategicamente para garantir cobertura total da arena, eliminando eco e reverberação — problemas comuns em som tradicional nesse tipo de espaço.',
    },
    {
      question: 'É possível fazer múltiplas sessões simultâneas nos salões do Mané Garrincha?',
      answer:
        'Sim. A STIB opera canais de áudio independentes em cada salão modular do Mané Garrincha. Já realizamos eventos com até 6 trilhas simultâneas no complexo, cada uma com áudio cristalino e zero interferência entre espaços.',
    },
    {
      question: 'Com quanta antecedência devo reservar para evento no Mané Garrincha?',
      answer:
        'Para eventos de grande porte no Mané Garrincha, recomendamos 4 semanas de antecedência. A distância SP-Brasília e a escala dos eventos demandam planejamento logístico detalhado: transporte de equipamentos, dimensionamento da equipe técnica e coordenação com a administração do estádio.',
    },
  ],
  seoTitle:
    'Palestra Silenciosa Arena Mané Garrincha | Fones Sem Fio para Megaeventos em Brasília',
  seoDescription:
    'Palestra silenciosa no Estádio Nacional Mané Garrincha: aluguel de fones sem fio para congressos, convenções e megaeventos no Eixo Monumental, DF. Capacidade massiva. Orçamento!',
  heroImageSeq: 'venuemanegarrinchabsbhero',
  heroImageUrl: '/img/stib/cidade-brasilia.webp',
  mapEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3838.0!2d-47.9000!3d-15.7880!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTXCsDQ3JzE2LjgiUyA0N8KwNTQnMDAuMCJX!5e0!3m2!1spt-BR!2sbr!4v1',
};

// ─── Venue 15: Expotrade (Curitiba) ────────────────────────────────────────

export const EXPOTRADE_DATA: VenueData = {
  slug: 'palestra-silenciosa-expotrade-curitiba',
  name: 'Expotrade Convention Center',
  fullName: 'Expotrade Convention Center — Curitiba',
  website: 'expotrade.com.br',
  location: 'Curitiba (Região Metropolitana), PR',
  address: 'Rod. Dep. João Leopoldo Jacomel, 10454 — Vila Amelia, Pinhais, PR',
  neighborhood: 'Pinhais (Região Metropolitana de Curitiba)',
  description:
    'O Expotrade Convention Center é um dos maiores e mais modernos centros de eventos do sul do Brasil, localizado em Pinhais, na região metropolitana de Curitiba. Com 34.000m² de área construída, 55.000m² de área externa, climatização total e mais de 3.000 vagas de estacionamento, o Expotrade sedia feiras de negócios, congressos, convenções corporativas, shows e eventos de grande porte que atendem Curitiba e todo o Paraná.',
  capacity: 'Grandes feiras e congressos com milhares de participantes',
  area: '34.000m² de área construída e 55.000m² de área externa',
  parking: 'Mais de 3.000 vagas de estacionamento',
  eventTypes: [
    'Feiras de negócios e exposições',
    'Congressos e convenções',
    'Eventos corporativos',
    'Shows e eventos de entretenimento',
    'Lançamentos de produto',
    'Feiras setoriais e industriais',
  ],
  features: [
    '34.000m² de área construída totalmente climatizada',
    '55.000m² de área externa para eventos ao ar livre',
    'Mais de 3.000 vagas de estacionamento',
    'Infraestrutura moderna com tecnologia audiovisual de ponta',
    'Maior centro de eventos do sul do Brasil',
    'Localização estratégica na região metropolitana de Curitiba',
  ],
  whySilentLectureWorks: [
    'A área de 34.000m² do Expotrade comporta feiras com centenas de estandes — a palestra silenciosa permite que cada expositor faça apresentações sem poluição sonora',
    'Eventos simultâneos em diferentes alas do Expotrade são comuns — os canais RF independentes garantem que cada área opere acusticamente isolada',
    'A climatização total e a estrutura moderna do Expotrade são complementadas pela tecnologia RF da STIB — áudio cristalino em qualquer ponto do pavilhão',
    'Feiras industriais e setoriais no Expotrade atraem milhares de visitantes — os fones sem fio funcionam perfeitamente mesmo em ambientes densamente ocupados',
    'A localização em Pinhais (acesso pela rodovia) facilita a logística da STIB a partir de São Paulo — entrega rápida pela BR-116',
  ],
  stibAdvantages: [
    'Capacidade para atender feiras e congressos de grande porte no Expotrade',
    'Fones RF com alcance de 500m cobrem os 34.000m² do pavilhão',
    'Logística SP → Curitiba otimizada pela BR-116 (aproximadamente 6h)',
    'Múltiplos canais de áudio para palestras simultâneas em diferentes estandes e auditórios',
    'Montagem rápida que se integra à infraestrutura moderna do Expotrade',
    'Suporte técnico presencial durante toda a programação em Curitiba',
  ],
  localKeywords: [
    'palestra silenciosa Expotrade Curitiba',
    'fones sem fio Expotrade Pinhais eventos',
    'silent conference Curitiba PR',
    'eventos corporativos Curitiba palestra silenciosa',
    'feira Expotrade fones sem fio',
  ],
  faqs: [
    {
      question: 'A STIB atende eventos no Expotrade, em Curitiba?',
      answer:
        'Sim, a STIB atende eventos no Expotrade Convention Center, em Pinhais (região metropolitana de Curitiba). Nossa logística pela BR-116 é rápida e eficiente — aproximadamente 6 horas de São Paulo. Entregamos equipamentos, montamos e damos suporte presencial durante todo o evento.',
    },
    {
      question: 'Os fones da STIB funcionam bem em uma área de 34.000m²?',
      answer:
        'Sim, nossos fones RF têm alcance de 500m em linha reta com transmissores posicionados estrategicamente. Para o Expotrade, dimensionamos múltiplos pontos de transmissão para garantir cobertura total dos 34.000m², incluindo áreas de circulação e externas.',
    },
    {
      question: 'A STIB consegue atender feiras com palestras em múltiplos estandes no Expotrade?',
      answer:
        'Sim, e é o cenário ideal para feiras no Expotrade. Cada estande ou auditório recebe seu canal de áudio independente. Os visitantes ouvem apenas o conteúdo do estande onde estão — sem interferência, sem ruído, experiência imersiva total.',
    },
    {
      question: 'Quanto tempo de viagem de SP para o Expotrade?',
      answer:
        'São aproximadamente 6 horas pela BR-116 (Régis Bittencourt) até Pinhais. Nossa equipe viaja com antecedência e os equipamentos são transportados com seguro, garantindo que tudo chegue em perfeitas condições para a montagem no Expotrade.',
    },
    {
      question: 'Vale a pena contratar a STIB para um evento em Curitiba?',
      answer:
        'Vale muito, especialmente para eventos de médio e grande porte no Expotrade. A STIB é referência nacional em palestra silenciosa, e nossa tecnologia RF é comprovadamente superior. O custo da logística se dilui no orçamento de eventos maiores, e você tem a tranquilidade de um fornecedor premium operando o áudio do seu evento.',
    },
  ],
  seoTitle:
    'Palestra Silenciosa Expotrade Curitiba | Fones Sem Fio para Feiras e Congressos',
  seoDescription:
    'Palestra silenciosa no Expotrade Curitiba: aluguel de fones sem fio para feiras, congressos e eventos corporativos em Pinhais, PR. Maior centro de eventos do sul do Brasil. Orçamento!',
  heroImageSeq: 'venueexpotradecuritibahero',
  heroImageUrl: '/img/stib/local-espaco-contemporaneo.webp',
  mapEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3602.0!2d-49.1700!3d-25.4300!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjXCsDI1JzQ4LjAiUyA0OcKwMTAnMTIuMCJX!5e0!3m2!1spt-BR!2sbr!4v1',
};

// ─── All venues array ────────────────────────────────────────────────────────

export const ALL_VENUES = [
  TRANSAMERICA_DATA,
  EXPOCENTER_DATA,
  FREICANECA_DATA,
  ANHEMBI_DATA,
  WTC_DATA,
  VILLABISUTTI_DATA,
  TOKIOMARINE_DATA,
  RIOCENTRO_DATA,
  SULAMERICA_DATA,
  EXPOMINAS_DATA,
  MINASCENTRO_DATA,
  BRASIL21_DATA,
  DOISIPES_DATA,
  MANEGARRINCHA_DATA,
  EXPOTRADE_DATA,
];

export function getVenueBySlug(slug: string): VenueData | undefined {
  return ALL_VENUES.find((v) => v.slug === slug);
}